var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', [_c('loading-overlay', {
    attrs: {
      "wait-for": _vm.processing,
      "light": ""
    }
  }), _vm._v(" "), _vm.error ? _c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_c('h1', {
    staticClass: "my-8"
  }, [_vm._v("Something went wrong 😶")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm.isDev ? _c('pre', {
    staticClass: "text-sm opacity-75"
  }, [_vm._v(_vm._s(JSON.stringify(_vm.error, undefined, 2)))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "my-4 mt-10 button--filled",
    on: {
      "click": _vm.reloadPage
    }
  }, [_vm._v("Try again")])])]) : _vm.success ? _c('div', {
    staticClass: "h-screen px-4 py-6 flex flex-col justify-center items-center text-center space-y-8"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "font-semibold text-2xl leading-7"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.lastChargeAuthorized ? 'Scheduled payment has been cancelled.' : 'Thank you for scheduling your payment.') + "\n\t\t")])]) : _vm.lastCharge && !_vm.lastChargeAuthorized ? _c('confirmation-screen', {
    staticClass: "pt-10 sm-md:pt-0",
    attrs: {
      "title": "Schedule your next payment",
      "policies": _vm.policyTimestamps,
      "plans": _vm.plans,
      "plan": _vm.plan,
      "plan-header-text": "Plan type",
      "allow-plan-change": false,
      "allow-autopay-change": true,
      "plan-autopay": _vm.planAutopay,
      "show-cha-policy": false,
      "continue-button-text": "Make a payment",
      "continue-button-action": _vm.submit,
      "scheduled-payment": true,
      "metadata": _vm.achPolicyMetadata
    },
    on: {
      "update:policies": function ($event) {
        _vm.policyTimestamps = $event;
      },
      "update:planAutopay": function ($event) {
        _vm.planAutopay = $event;
      },
      "update:plan-autopay": function ($event) {
        _vm.planAutopay = $event;
      },
      "showThisDisclosure": _vm.showThisDisclosure
    }
  }) : _vm.lastCharge && _vm.lastChargeAuthorized ? _c('confirmation-screen', {
    staticClass: "pt-10 sm-md:pt-0",
    attrs: {
      "title": "Your scheduled payment",
      "policies": _vm.policyTimestamps,
      "plans": _vm.plans,
      "plan": _vm.plan,
      "plan-header-text": "Plan type",
      "allow-plan-change": false,
      "allow-autopay-change": false,
      "plan-autopay": _vm.planAutopay,
      "show-cha-policy": false,
      "show-ach-policy": false,
      "continue-button-text": "Cancel payment",
      "continue-button-action": () => _vm.showCancelModal = true,
      "scheduled-payment": true,
      "metadata": _vm.achPolicyMetadata
    },
    on: {
      "update:policies": function ($event) {
        _vm.policyTimestamps = $event;
      },
      "update:planAutopay": function ($event) {
        _vm.planAutopay = $event;
      },
      "update:plan-autopay": function ($event) {
        _vm.planAutopay = $event;
      },
      "showThisDisclosure": _vm.showThisDisclosure
    }
  }) : _vm._e(), _vm._v(" "), _c('disclosure-modal', {
    attrs: {
      "show": _vm.showDisclosure,
      "disclosure": _vm.disclosureFile,
      "metadata": _vm.achPolicyMetadata
    },
    on: {
      "close": () => _vm.showDisclosure = false
    }
  }), _vm._v(" "), _c('modal-overlay', {
    attrs: {
      "open": _vm.showCancelModal,
      "blur": false
    }
  }, [_c('div', {
    staticClass: "mx-4 rounded-lg px-4 py-6 flex flex-col justify-center items-center space-y-2 text-center bg-white"
  }, [_c('h3', {
    staticClass: "font-medium text-xl leading-7"
  }, [_vm._v("\n\t\t\t\tAre you sure you want to cancel scheduled payment?\n\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "pb-4 leading-6",
    staticStyle: {
      "color": "#3d3c3c"
    }
  }, [_vm._v("\n\t\t\t\tMissed membership payments may result in service interruptions.\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "w-full button--filled",
    on: {
      "click": _vm.cancelPayment
    }
  }, [_vm._v("Yes, cancel it.")]), _vm._v(" "), _c('button', {
    staticClass: "w-full",
    on: {
      "click": () => _vm.showCancelModal = false
    }
  }, [_vm._v("\n\t\t\t\tNo, I changed my mind.\n\t\t\t")])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "my-4 text-xl leading-9"
  }, [_vm._v("\n\t\t\t\tFeel free to try again, and if the issue persists, please contact Member Concierge at\n\t\t\t\t"), _c('a', {
    attrs: {
      "href": "mailto:hey@extra.app"
    }
  }, [_vm._v("hey@extra.app")]), _vm._v(" and we’ll get this resolved right away.\n\t\t\t")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "success-icon"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/check-success.svg")
    }
  })]);
}];
export { render, staticRenderFns };